<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.0593 7.10279C14.3802 6.78188 14.3802 6.26159 14.0593 5.94068C13.7384 5.61977 13.2181 5.61977 12.8972 5.94068L10 8.83788L7.10281 5.94068C6.7819 5.61977 6.2616 5.61977 5.94069 5.94068C5.61978 6.26159 5.61978 6.78188 5.94069 7.10279L8.8379 10L5.94069 12.8972C5.61978 13.2181 5.61978 13.7384 5.94069 14.0593C6.2616 14.3802 6.7819 14.3802 7.10281 14.0593L10 11.1621L12.8972 14.0593C13.2181 14.3802 13.7384 14.3802 14.0593 14.0593C14.3802 13.7384 14.3802 13.2181 14.0593 12.8972L11.1621 10L14.0593 7.10279Z"
            fill="currentColor"
        />
    </svg>
</template>
